import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import "../styling/sidebar.css";
import "../styling/expensepop.css";
import GetUser from "../services/get-user";
import { CircularProgress } from "@material-ui/core";

export default function SRPopup(props) {
  const [name, setName] = useState(props.keydata.name);
  const [amount, setAmount] = useState(props.keydata.amount);
  const [saleID, setsaleID] = useState(props.keydata._id);
  const [fee, setFee] = useState(props.keydata.fee);
  const [note, setNote] = useState(props.keydata.note);
  const [usedate, setUseDate] = useState(new Date(props.keydata.realDate));
  const [customer, setCustomer] = useState(props.keydata.customer);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const user = GetUser();
 

  function validateForm() {
    return name.length > 0 && customer.length > 0 && parseInt(amount) >= 0;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      //'http://localhost:8080/income/add_income'
      //return axios.post('http://localhost:8080/sale/remove_sale', {
      return axios
        .post("https://sotira-back-test.herokuapp.com/sale/remove_sale", {
          userID: user.userID,
          saleID: saleID,
        })
        .then((response) => {
          sessionStorage.setItem("option", "sales");
          setLoading(false);
          props.closeRemoveModel(false);
          props.setReloadTableData((prevState)=>!prevState);
          props.setReloadAPI((prevState)=>!prevState);
        });
    } catch (e: any) {
      alert(e.message);
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="name" className="form-group required">
        <Form.Label className="control-label"> Product Name </Form.Label>
        <Form.Control autoFocus type="name" value={name} readOnly />
      </Form.Group>

      <Form.Group controlId="date">
        <Form.Label> Date Sold </Form.Label>
        <DatePicker
          readOnly
          selected={usedate}
          onChange={(date) => setUseDate(date)}
          showTimeSelect
          dateFormate="Pp"
          className="date-picker-input"
        />
      </Form.Group>

      <Form.Group controlId="amount" className="form-group required">
        <Form.Label className="control-label"> Amount $ </Form.Label>
        <div className="d-flex">
        <span className="font-currency mr-2 mt-1">$</span>
          <Form.Control autoFocus step={0.01} value={amount} readOnly />
        </div>
      </Form.Group>

      <Form.Group controlId="cust" className="form-group required">
        <Form.Label className="control-label"> Customer Name </Form.Label>
        <Form.Control autoFocus type="cust" value={customer} readOnly />
      </Form.Group>

      <Form.Group controlId="fee">
        <Form.Label className="control-label"> Fee $ </Form.Label>
        <Form.Control
          autoFocus
          type="number"
          step={0.01}
          value={fee}
          readOnly
        />
      </Form.Group>

      <Form.Group controlId="note">
        <Form.Label> Note </Form.Label>
        <Form.Control autoFocus type="note" value={note} readOnly />
      </Form.Group>

      <Button block size="sm" type="submit" disabled={!validateForm()}>
      {loading ?
        <><CircularProgress className="file-loader mr-3" />Removing</>
        : 'Remove Sale'
      }  
      </Button>
    </Form>
  );
}
